export const isNetworkUrl = (url: string) => /^https?:\/\//i.test(url)

const BUG_STATUS_THEME_COUNT = 6

/** 缺陷状态下拉配色序号（1–6），与 @spBugStatus 一致 */
export const getBugStatusThemeIndex = (
  statusList: { status: number }[],
  statusId?: number
): number => {
  if (statusId == null || !statusList.length) {
    return 1
  }
  const idx = statusList.findIndex((s) => s.status === statusId)
  if (idx < 0) {
    return 1
  }
  return Math.min(idx + 1, BUG_STATUS_THEME_COUNT)
}

export const isImg = (name) => {
  return /\.(png|jpg|jpeg|gif|webp|bmp|svg|ico)$/i.test(name)
}
export const isVideo = (name) => {
  return /\.(mp4)$/i.test(name)
}
